import(/* webpackMode: "eager" */ "/var/www/mekanet/src/app/[lang]/loading.tsx");
